var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgMyTasksFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25H11.25M10 8.75H11.25M5 11.25H11.25M5 13.75H11.25M13.75 6.25H16.5625C17.0803 6.25 17.5 6.66973 17.5 7.1875V15C17.5 16.0355 16.6605 16.875 15.625 16.875M13.75 6.25V15C13.75 16.0355 14.5895 16.875 15.625 16.875M13.75 6.25V4.0625C13.75 3.54473 13.3303 3.125 12.8125 3.125H3.4375C2.91973 3.125 2.5 3.54473 2.5 4.0625V15C2.5 16.0355 3.33947 16.875 4.375 16.875H15.625M5 6.25H7.5V8.75H5V6.25Z",
    stroke: "#216AE2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgMyTasksFocus);
export default __webpack_public_path__ + "static/media/svg_my_tasks_focus.e6cd8571b21210eee32a8c27c60777d4.svg";
export { ForwardRef as ReactComponent };